/**
 * /frontend/src/features/analytics/components/customers/VisitGapHistogram.js
 */

import React from 'react';
import ChartContainer from '../shared/ChartContainer';
import HistogramChart from '../charts/HistogramChart';

/**
 * Distribution of visit gaps.
 * @param {{data:Array<{bucket:string,customerCount:number}>}} props
 * @returns {JSX.Element}
 */
const VisitGapHistogram = ({ data }) => (
  <ChartContainer title="Visit Gaps" subtitle="Days between visits (bucketed)">
    <HistogramChart data={data} xKey="bucket" yKey="customerCount" />
  </ChartContainer>
);

export default VisitGapHistogram;

